// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__NnLeB","large":"Badge_large__Vlfnv","flicker":"Badge_flicker__UH8H1","fadeIn":"Badge_fadeIn__wgsCl"};